import { combineReducers } from 'redux'

import tiposUnidadesMedidas from './tiposUnidadesMedidas'
import unidadesMedidas from './unidadesMedidas'

export default combineReducers({
  tiposUnidadesMedidas,
  unidadesMedidas
})